// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"c233c126","105":"5ce8db38","157":"a1ab1c52","466":"bcb457d9","508":"706ce0bf","536":"bf7af681","654":"271e8e52","671":"2c70d661","780":"9d7fa284","919":"417b0ba3","966":"5bd6a574"}[chunkId] + ".chunk.js";
};